"use client";
import React from "react";
import * as NavigationMenu from "@radix-ui/react-navigation-menu";
// import classNames from 'classnames';
import { CaretDownIcon } from "@radix-ui/react-icons";
// import './styles.css';
import { cn } from "@/lib/utils";
// import { Link } from "@/i18n/navigation";
import { Link } from "@/i18n/navigation";
import { Button } from "@/components/ui/Button";

// import ListItem from './ListItem'

const NavMenu = () => {
  return (
    // <NavigationMenu.Root  className="hidden center md:block flex
    <NavigationMenu.Root
      className="hidden center md:block  "
      style={{ justifyContent: "center", alignItems: "center" }}
    >
      <NavigationMenu.List className="center shadow-blackA4 flex list-none rounded-[6px] bg-card p-1 shadow-[0_2px_10px]">
        {/* <NavigationMenu.Item className="hover:opacity-100 opacity-70">
          <NavigationMenu.Trigger className="text-violet11 hover:bg-violet3 focus:shadow-violet7 group flex select-none items-center justify-between gap-[2px] rounded-[4px] px-3 py-2 text-[15px] font-medium leading-none outline-none focus:shadow-[0_0_0_2px]">
            Features{" "}
            <CaretDownIcon
              className="text-violet10 relative top-[1px] transition-transform  ease-in group-data-[state=open]:-rotate-180"
              aria-hidden
            />
          </NavigationMenu.Trigger>
          <NavigationMenu.Content className="w-full data-[motion=from-start]:animate-enterFromLeft data-[motion=from-end]:animate-enterFromRight data-[motion=to-start]:animate-exitToLeft data-[motion=to-end]:animate-exitToRight absolute top-0 left-0  sm:w-auto">
            <ul className="one m-0 grid list-none gap-x-[10px] p-[22px] sm:w-[500px] sm:grid-cols-[0.75fr_1fr]">
              <li className="row-span-3 grid">
                <NavigationMenu.Link asChild>
                  <a
                    className="focus:shadow-violet7 from-purple9 to-indigo9 flex
                      h-full w-full select-none flex-col justify-end rounded-[6px] bg-gradient-to-b p-[25px] no-underline outline-none focus:shadow-[0_0_0_2px]"
                    href="/features"
                  >
                    <svg
                      aria-hidden
                      width="38"
                      height="38"
                      viewBox="0 0 25 25"
                      fill="white"
                    >
                      <path d="M12 25C7.58173 25 4 21.4183 4 17C4 12.5817 7.58173 9 12 9V25Z"></path>
                      <path d="M12 0H4V8H12V0Z"></path>
                      <path d="M17 8C19.2091 8 21 6.20914 21 4C21 1.79086 19.2091 0 17 0C14.7909 0 13 1.79086 13 4C13 6.20914 14.7909 8 17 8Z"></path>
                    </svg>
                    <div className="mt-4 mb-[7px] text-[18px] font-medium leading-[1.2] text-white">
                      10+ Templates for inspiration
                    </div>
                    <p className="text-mauve4 text-[14px] leading-[1.3]">
                      e-com, agency, saas, business, portfolio,...
                    </p>
                  </a>
                </NavigationMenu.Link>
              </li>

              <ListItem href="/features" title="HTML">
                Static websites in Pure HTML,CSS and JS with best-in-class
                developer experience.
              </ListItem>
              <ListItem href="/features#React" title="React">
                Beautiful, modern and feature rich ReactJS app.
              </ListItem>
              <ListItem href="/features#vue" title="Vue">
                Beautiful, modern and feature rich Vue app.
              </ListItem>
            </ul>
          </NavigationMenu.Content>
        </NavigationMenu.Item> */}
        {/* <NavigationMenu.Item className="hover:opacity-100 opacity-70">
        <Button
            variant="ghost"
            size="sm"
            className="rounded-full p-2"
            // className="text-violet11 hover:bg-violet3 focus:shadow-violet7 block select-none rounded-[4px] px-3 py-2 text-[15px] font-medium leading-none no-underline outline-none focus:shadow-[0_0_0_2px]"
            href="/templates"
          >
            Templates
          </Button>
        <NavigationMenu.Trigger className="text-violet11 hover:bg-violet3 focus:shadow-violet7 group flex select-none items-center justify-between gap-[2px] rounded-[4px] px-3 py-2 text-[15px] font-medium leading-none outline-none focus:shadow-[0_0_0_2px]">
            Templates{" "}
            <CaretDownIcon
              className="text-violet10 relative top-[1px] transition-transform  ease-in group-data-[state=open]:-rotate-180"
              aria-hidden
            />
          </NavigationMenu.Trigger>
          <NavigationMenu.Content className="w-full data-[motion=from-start]:animate-enterFromLeft data-[motion=from-end]:animate-enterFromRight data-[motion=to-start]:animate-exitToLeft data-[motion=to-end]:animate-exitToRight absolute top-0 left-0  sm:w-auto">
            <ul className="one m-0 grid list-none gap-x-[10px] p-[22px] sm:w-[500px] sm:grid-cols-[0.75fr_1fr]">
              <li className="row-span-3 grid">
                <NavigationMenu.Link asChild>
                  <a
                    className="focus:shadow-violet7 from-purple9 to-indigo9 flex
                      h-full w-full select-none flex-col justify-end rounded-[6px] bg-gradient-to-b p-[25px] no-underline outline-none focus:shadow-[0_0_0_2px]"
                    href="/templates"
                  >
                    <svg
                      aria-hidden
                      width="38"
                      height="38"
                      viewBox="0 0 25 25"
                      fill="white"
                    >
                      <path d="M12 25C7.58173 25 4 21.4183 4 17C4 12.5817 7.58173 9 12 9V25Z"></path>
                      <path d="M12 0H4V8H12V0Z"></path>
                      <path d="M17 8C19.2091 8 21 6.20914 21 4C21 1.79086 19.2091 0 17 0C14.7909 0 13 1.79086 13 4C13 6.20914 14.7909 8 17 8Z"></path>
                    </svg>
                    <div className="mt-4 mb-[7px] text-[18px] font-medium leading-[1.2] text-white">
                      10+ Templates for inspiration
                    </div>
                    <p className="text-mauve4 text-[14px] leading-[1.3]">
                      e-com, agency, saas, business, portfolio,...
                    </p>
                  </a>
                </NavigationMenu.Link>
              </li>

              <ListItem href="/templates#HTML" title="HTML">
                Static websites in Pure HTML,CSS and JS with best-in-class
                developer experience.
              </ListItem>
              <ListItem href="/explorer" title="Explorer">
                Explore Github repositories and open source projects.
              </ListItem>
              <ListItem href="/templates#vue" title="Vue">
                Beautiful, modern and feature rich Vue app.
              </ListItem>
            </ul>
          </NavigationMenu.Content> 
         </NavigationMenu.Item> */}
        <NavigationMenu.Item className="hover:opacity-100 opacity-70">
          {/* <Link
            className="text-violet11 hover:bg-violet3 focus:shadow-violet7 block select-none rounded-[4px] px-3 py-2 text-[15px] font-medium leading-none no-underline outline-none focus:shadow-[0_0_0_2px]"
            href="/top-up"
          >
            Buy Credits
          </Link> */}
          <Button
            variant="ghost"
            size="sm"
            className="rounded-full p-2"
            href="/top-up"
          >
            Buy Credits
          </Button>
        </NavigationMenu.Item>
        <NavigationMenu.Item className="hover:opacity-100 opacity-70">
          <Button
            variant="ghost"
            size="sm"
            className="rounded-full p-2"
            asChild
          >
            <Link href="/pricing">Pricing</Link>
          </Button>
          {/* <NavigationMenu.Trigger className="text-violet11 hover:bg-violet3 focus:shadow-violet7 group flex select-none items-center justify-between gap-[2px] rounded-[4px] px-3 py-2 text-[15px] font-medium leading-none outline-none focus:shadow-[0_0_0_2px]">
            Pricing
            <CaretDownIcon
              className="text-violet10 relative top-[1px] transition-transform ease-in group-data-[state=open]:-rotate-180"
              aria-hidden
            />
          </NavigationMenu.Trigger> */}
          {/* <NavigationMenu.Content className="data-[motion=from-start]:animate-enterFromLeft data-[motion=from-end]:animate-enterFromRight data-[motion=to-start]:animate-exitToLeft data-[motion=to-end]:animate-exitToRight absolute top-0 left-0 w-full sm:w-auto">
            <ul className="one m-0 grid list-none gap-x-[10px] p-[22px] sm:w-[500px] sm:grid-cols-[0.75fr_1fr]">
              <li className="row-span-4 grid">
                <NavigationMenu.Link asChild>
                  <a
                    className="focus:shadow-violet7 from-purple9 to-indigo9 flex
                      h-full w-full select-none flex-col justify-end rounded-[6px] bg-gradient-to-b p-[25px] no-underline outline-none focus:shadow-[0_0_0_2px]"
                    href="/pricing"
                  >
                    <svg
                      aria-hidden
                      width="38"
                      height="38"
                      viewBox="0 0 25 25"
                      fill="white"
                    >
                      <path d="M12 25C7.58173 25 4 21.4183 4 17C4 12.5817 7.58173 9 12 9V25Z"></path>
                      <path d="M12 0H4V8H12V0Z"></path>
                      <path d="M17 8C19.2091 8 21 6.20914 21 4C21 1.79086 19.2091 0 17 0C14.7909 0 13 1.79086 13 4C13 6.20914 14.7909 8 17 8Z"></path>
                    </svg>
                    <div className="mt-4 mb-[7px] text-[18px] font-medium leading-[1.2] text-white">
                      Free Plan
                    </div>
                    <p className="text-mauve4 text-[14px] leading-[1.3]">
                      To try out raffaello
                    </p>
                  </a>
                </NavigationMenu.Link>
              </li>

              <ListItem href="/pricing#starter" title="Starter">
                For hobbyist and web-enthousiasts
              </ListItem>
              <ListItem href="/pricing#pro" title="Pro">
                For professionals and freelancers
              </ListItem>
              <ListItem href="/pricing#agency" title="Agency">
                For Agency of 2-10 employees
              </ListItem>
              <ListItem href="/pricing#entreprise" title="Entreprise">
                For businesses that require different teams with different
                access
              </ListItem>
            </ul>
          </NavigationMenu.Content> */}
        </NavigationMenu.Item>

        <NavigationMenu.Item className="hover:opacity-100 opacity-70 justify-center items-center flex">
          <NavigationMenu.Trigger className="text-violet11 hover:bg-violet3 focus:shadow-violet7 group flex select-none items-center justify-between gap-[2px] rounded-[4px] px-3  font-medium leading-none outline-none focus:shadow-[0_0_0_2px]">
            Docs{" "}
            <CaretDownIcon
              className="text-violet10 relative top-[1px] transition-transform duration-[250] ease-in group-data-[state=open]:-rotate-180"
              aria-hidden
            />
          </NavigationMenu.Trigger>
          <NavigationMenu.Content className="bg-card data-[motion=from-start]:animate-enterFromLeft data-[motion=from-end]:animate-enterFromRight data-[motion=to-start]:animate-exitToLeft data-[motion=to-end]:animate-exitToRight absolute top-0 left-0 w-full sm:w-auto">
            <ul className="one m-0 grid list-none gap-x-[10px] p-[22px] sm:w-[500px] sm:grid-cols-[0.75fr_1fr]">
              <li className="row-span-4 grid p-2">
                <NavigationMenu.Link asChild>
                  <a
                    className="focus:shadow-violet7 from-purple9 to-indigo9 flex
                      h-full w-full select-none flex-col justify-end rounded-[6px] bg-gradient-to-b p-[25px] no-underline outline-none focus:shadow-[0_0_0_2px]"
                    href="/docs"
                  >
                    <svg
                      aria-hidden
                      width="38"
                      height="38"
                      viewBox="0 0 25 25"
                      fill="white"
                    >
                      <path d="M12 25C7.58173 25 4 21.4183 4 17C4 12.5817 7.58173 9 12 9V25Z"></path>
                      <path d="M12 0H4V8H12V0Z"></path>
                      <path d="M17 8C19.2091 8 21 6.20914 21 4C21 1.79086 19.2091 0 17 0C14.7909 0 13 1.79086 13 4C13 6.20914 14.7909 8 17 8Z"></path>
                    </svg>
                    <div className="mt-4 mb-[7px] text-[18px] font-medium leading-[1.2] text-white">
                      Radix Primitives
                    </div>
                    <p className="text-mauve4 text-[14px] leading-[1.3]">
                      Unstyled, accessible components for React.
                    </p>
                  </a>
                </NavigationMenu.Link>
              </li>

              <ListItem href="/docs#getting-started" title="Getting Started">
                Getting Started
              </ListItem>
              <ListItem href="/docs#builder" title="Builder">
                Using our Builder to build your website
              </ListItem>
              <ListItem href="/docs#cms" title="CMS">
                The AI Powered Content Management System
              </ListItem>
              <ListItem href="/docs#deploy" title="Launch your website">
                Deploy your code
              </ListItem>
            </ul>
          </NavigationMenu.Content>
        </NavigationMenu.Item>

        {/* <NavigationMenu.Item className="hover:opacity-100 opacity-70">
          <Button
            variant="ghost"
            size="sm"
            className="rounded-full p-2"
            href="/why-connect-github"
          >
            Why connect Github
          </Button>
        </NavigationMenu.Item> */}
        <NavigationMenu.Item className="hover:opacity-100 opacity-70">
          <Button
            variant="ghost"
            size="sm"
            className="rounded-full p-2"
            href="https://discord.gg/nNCnHybP"
          >
            Discord
          </Button>
        </NavigationMenu.Item>
        <NavigationMenu.Indicator className="data-[state=visible]:animate-fadeIn data-[state=hidden]:animate-fadeOut top-full z-[1] flex h-[10px] items-end justify-center overflow-hidden transition-[width,transform_250ms_ease]">
          <div className="relative  top-[70%] h-[20px] w-[20px] rotate-[45deg] rounded-tl-[2px]  bg-accent" />
        </NavigationMenu.Indicator>
      </NavigationMenu.List>

      <div className="perspective-[2000px] p-50 absolute top-full left-0 flex w-full grow justify-center">
        <NavigationMenu.Viewport className="w-full shadow-blackA4 flex list-none rounded-[6px] bg-card p-1 shadow-[0_2px_10px] data-[state=open]:animate-scaleIn data-[state=closed]:animate-scaleOut relative mt-[10px] h-[var(--radix-navigation-menu-viewport-height)] origin-[top_center] overflow-hidden  transition-[width,_height] duration-300 lg:w-[var(--radix-navigation-menu-viewport-width)]" />
      </div>
    </NavigationMenu.Root>
  );
};

const NavigationMenuLink = Link;
interface ListItemProps {
  href: string;
  title: string;
  children: React.ReactNode;
}

const ListItem = React.forwardRef<HTMLAnchorElement, ListItemProps>(
  ({ href, title, children, ...props }, ref) => {
    return (
      <li>
        <NavigationMenuLink href={href}>
          <div
            className={cn(
              " block select-none space-y-1 font-medium leading-none pt-2 w-full"
              // props.className // Include className from props
            )}
            // href={href} // Add href attribute
            {...props}
          >
            <div className="text-white text-md font-bold leading-none">
              {title}
            </div>
            <p
              className="group-hover:text-white/70
                      line-clamp-2
                      text-lg
                      leading-snug
                      text-white/40
                    "
            >
              {children}
            </p>
          </div>
        </NavigationMenuLink>
      </li>
    );
  }
);
ListItem.displayName = "ListItem";
export default NavMenu;

// #5c3df5
// #c084fc
